import { render, staticRenderFns } from "./TicketIntroFixed.vue?vue&type=template&id=ef41c598&scoped=true&"
import script from "./TicketIntroFixed.vue?vue&type=script&lang=js&"
export * from "./TicketIntroFixed.vue?vue&type=script&lang=js&"
import style0 from "./TicketIntroFixed.vue?vue&type=style&index=0&id=ef41c598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef41c598",
  null
  
)

export default component.exports